import CollectionImage from './CollectionImage.container'

export default CollectionImage
